export enum LoopType {
  Collisions = 'collisions',
  Controls = 'controls',
  Intersections = 'intersections',
  Kinematic = 'kinematic',
  Mouse = 'mouse',
  Physics = 'physics',
  Render = 'render',
  Audio = 'audio',
  Spatial = 'spatial',
  Text = 'text',
  Transform = 'transform'
}
